const bigContext = require.context("../../img/gallery/BIG", false, /\.(jpe?g|png|webp)$/);
const smallContext = require.context("../../img/gallery/SMALL", false, /\.(jpe?g|png|webp)$/);
const videoContext = require.context("../../img/gallery/HOVER_VIDEOS", false, /\.(mp4|webm)$/);

const bigKeys = bigContext.keys().sort((a, b) => {
  const numA = parseInt(a.replace('./', ''));
  const numB = parseInt(b.replace('./', ''));
  return numA - numB;
});

// 1. Create the base gallery from images
let combinedGallery = bigKeys.map((key) => {
  const resBig = bigContext(key);
  const resSmall = smallContext(key);
  
  // Look for a video with the same number (e.g., 1.mp4)
  const videoKey = key.replace(/\.[^/.]+$/, ".mp4");
  let hoverVideo = null;
  try {
    const resVideo = videoContext(videoKey);
    hoverVideo = resVideo.default || resVideo;
  } catch (e) {
    hoverVideo = null; 
  }

  return {
    big: resBig.default || resBig,
    small: resSmall.default || resSmall,
    hoverVideo: hoverVideo,
    tipo: "image"
  };
});

// 2. Define Vimeo Videos to inject
const videosToInject = [
  // {
  //   index: 4, 
  //   data: {
  //     big: "https://vimeo.com/859900574",
  //     small: "https://vimeo.com/859900574",
  //     tipo: "video",
  //     link
  //   }
  // },
  // {
  //   index: 10,
  //   data: {
  //     big: "https://vimeo.com/853157093",
  //     small: "https://vimeo.com/853157093",
  //     tipo: "video",
  //   }
  // }
];

// 3. Insert videos into the array
videosToInject
  .sort((a, b) => b.index - a.index)
  .forEach(vid => {
    combinedGallery.splice(vid.index, 0, vid.data);
  });

// Define which image indices should have links
// Note: Use the index they have AFTER the videos are spliced in
const imageLinks = [
  { index: 0, link: "" },
];

imageLinks.forEach(item => {
  // Only apply the link if the item exists and is an image
  if (combinedGallery[item.index] && combinedGallery[item.index].tipo === "image") {
    combinedGallery[item.index].link = item.link;
  }
});

  // 4. Export the result
const img = combinedGallery; 
export { img };